const UAT_VISITOR_API_URL = "https://dus6ln3su7.execute-api.ap-south-1.amazonaws.com/uat/create_visitor";
const PROD_VISITOR_API_URL = "https://eff51g1kg9.execute-api.ap-south-1.amazonaws.com/prod/create_visitor";

const UAT_API_URL = "https://dus6ln3su7.execute-api.ap-south-1.amazonaws.com/uat/save_leadData";
const PROD_API_URL = "https://eff51g1kg9.execute-api.ap-south-1.amazonaws.com/prod/save_leadData";

const getApiUrl = () => {
    const hostname = window.location.hostname;

    // Check if running locally
    if (hostname === "localhost" || hostname === "dev.ikigai365.com") {
        return UAT_API_URL;
    }
    return PROD_API_URL;
};

const getVisitorApiUrl = () => {
    const hostname = window.location.hostname;

    // Check if running locally
    if (hostname === "localhost" || hostname === "dev.ikigai365.com") {
        return UAT_VISITOR_API_URL;
    }
    return PROD_VISITOR_API_URL;
};

export const API_URL = getApiUrl();
export const VISITOR_API_URL = getVisitorApiUrl();
